import { Chip } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledChip = styled(Chip)({
  marginLeft: '8px',
})

export const Role = styled('div')({
  display: 'flex',
  alignItems: 'center',
})
